import { render, staticRenderFns } from "./IssuedItem.vue?vue&type=template&id=ee1b434e"
import script from "./IssuedItem.vue?vue&type=script&lang=js"
export * from "./IssuedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports